import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';
import { MessageService } from '../services/message.service';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        private messageService: MessageService,
        private router: Router
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error) => {
                if (error == null || error.status == 500) {
                    this.messageService.warning('Errore interno di sistema!');
                    return throwError(error);
                }
                if (error instanceof HttpErrorResponse && error.status === 403) {
                    this.router.navigate(['dashboard']);
                }
                switch (error.status) {
                    case 401:
                        // this.messageService.warning('Autenticazione fallita! Rieffettuare il login.');
                        break;
                    case 504:
                        this.messageService.warning('Errore di sistema - Timeout');
                        break;
                }
                if (error instanceof HttpErrorResponse && error.headers.get('X-Application-Privacy') === 'Required') {
                    this.router.navigate(['/application-privacy']);
                }
                if (error?.error?.errors?.constructor.name === "Array") {
                    this.messageService.warning(error?.error?.errors?.join(', '));
                }
                return throwError(error);
            })
        );
    }

}
